module.exports = __webpack_public_path__ + "img/product_79.35962bd.webp";